import { useEffect } from 'react'
import { statusService } from '@flatfile/shared-ui'
import { useToast, Button, Icon } from '@flatfile/baseline'

export const StatusServiceInitializer = () => {
  const { toast } = useToast()

  useEffect(() => {
    statusService.startMonitoring((statusData) => {
      if (statusData.heading && statusData.message) {
        toast({
          duration: Infinity,
          title: (
            <div className='flex items-center gap-3'>
              <Icon name='triangle-exclamation' size={18} className='text-foreground flex-shrink-0' />
              <div className='flex-1'>
                <div className='text-foreground font-medium'>{statusData.heading}</div>
                <div className='text-foreground text-sm mt-1 font-normal'>{statusData.message}</div>
              </div>
            </div>
          ),
          action: statusData.action ? (
            <Button variant='primary' size='sm' onClick={statusData.action.onClick}>
              {statusData.action.label}
            </Button>
          ) : undefined,
        })
      }
    }, 'new-dashboard')

    return () => {
      statusService.stopMonitoring()
    }
  }, [toast])

  return null
}
